import { render, staticRenderFns } from "./de_attach_captain.vue?vue&type=template&id=7cfe6104&scoped=true&"
import script from "./de_attach_captain.vue?vue&type=script&lang=js&"
export * from "./de_attach_captain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfe6104",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cfe6104')) {
      api.createRecord('7cfe6104', component.options)
    } else {
      api.reload('7cfe6104', component.options)
    }
    module.hot.accept("./de_attach_captain.vue?vue&type=template&id=7cfe6104&scoped=true&", function () {
      api.rerender('7cfe6104', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/suppliers/actions/de_attach_captain.vue"
export default component.exports